export interface ComicCategory {
  id: string;
  name: string;
  icon: string;
  count: number;
  desc: string;
}

export interface ComicItem {
  id: string;
  title: string;
  category: string;
  tag: string;
  author: string;
  chapters: number;
  rating: number;
  views: string;
  image: string;
  badge?: string;
}

export const comicCategories: ComicCategory[] = [
  {
    id: "reman",
    name: "热血少年",
    icon: "ri-flashlight-line",
    count: 1280,
    desc: "燃向打斗与成长故事",
  },
  {
    id: "sweet",
    name: "甜蜜恋爱",
    icon: "ri-heart-line",
    count: 986,
    desc: "甜度满分的恋爱日常",
  },
  {
    id: "fantasy",
    name: "异世界幻想",
    icon: "ri-sparkling-line",
    count: 742,
    desc: "穿越与魔法冒险",
  },
  {
    id: "daily",
    name: "轻松日常",
    icon: "ri-emotion-happy-line",
    count: 563,
    desc: "治愈系校园与日常",
  },
  {
    id: "mystery",
    name: "悬疑推理",
    icon: "ri-search-eye-line",
    count: 418,
    desc: "烧脑反转与探案",
  },
  {
    id: "sport",
    name: "运动竞技",
    icon: "ri-trophy-line",
    count: 356,
    desc: "热血赛场拼搏",
  },
];

export const featuredComics: ComicItem[] = [
  {
    id: "c1",
    title: "星火少年团",
    category: "热血少年",
    tag: "热血",
    author: "虫虫工作室",
    chapters: 328,
    rating: 9.6,
    views: "2.3亿",
    image: "https://readdy.ai/api/search-image?query=energetic%20anime%20style%20comic%20cover%20of%20a%20teen%20boy%20with%20fiery%20orange%20flame%20aura%2C%20dynamic%20action%20pose%2C%20warm%20orange%20and%20amber%20color%20palette%2C%20bold%20line%20art%2C%20vibrant%20background%2C%20manga%20illustration&width=600&height=800&seq=cc-comic-01&orientation=portrait",
    badge: "热门榜",
  },
  {
    id: "c2",
    title: "星光恋曲物语",
    category: "甜蜜恋爱",
    tag: "恋爱",
    author: "夏目插画社",
    chapters: 156,
    rating: 9.3,
    views: "1.7亿",
    image: "https://readdy.ai/api/search-image?query=sweet%20romance%20anime%20comic%20cover%20with%20two%20teenagers%20under%20cherry%20blossom%20tree%20at%20sunset%2C%20soft%20pink%20and%20peach%20tones%2C%20gentle%20manga%20style%2C%20dreamy%20glow%2C%20warm%20illustration&width=600&height=800&seq=cc-comic-02&orientation=portrait",
    badge: "新作",
  },
  {
    id: "c3",
    title: "异界料理师",
    category: "异世界幻想",
    tag: "幻想",
    author: "清风漫画",
    chapters: 214,
    rating: 9.1,
    views: "9800万",
    image: "https://readdy.ai/api/search-image?query=fantasy%20anime%20comic%20cover%20of%20a%20chef%20in%20magical%20world%20cooking%20with%20glowing%20ingredients%2C%20teal%20and%20green%20magic%20energy%2C%20epic%20landscape%20background%2C%20manga%20illustration&width=600&height=800&seq=cc-comic-03&orientation=portrait",
  },
  {
    id: "c4",
    title: "放学后的约定",
    category: "轻松日常",
    tag: "日常",
    author: "糯米团子",
    chapters: 98,
    rating: 8.9,
    views: "6500万",
    image: "https://readdy.ai/api/search-image?query=cozy%20school%20life%20anime%20comic%20cover%20with%20students%20after%20class%2C%20warm%20golden%20afternoon%20light%2C%20soft%20pastel%20tones%2C%20heartwarming%20manga%20style%2C%20cheerful%20illustration&width=600&height=800&seq=cc-comic-04&orientation=portrait",
  },
  {
    id: "c5",
    title: "迷雾档案室",
    category: "悬疑推理",
    tag: "悬疑",
    author: "墨色侦探社",
    chapters: 187,
    rating: 9.4,
    views: "1.2亿",
    image: "https://readdy.ai/api/search-image?query=mystery%20thriller%20anime%20comic%20cover%20of%20detective%20in%20foggy%20room%20with%20case%20files%2C%20moody%20dark%20teal%20and%20amber%20lighting%2C%20dramatic%20manga%20style%2C%20intriguing%20illustration&width=600&height=800&seq=cc-comic-05&orientation=portrait",
    badge: "口碑作",
  },
  {
    id: "c6",
    title: "球场上的王者",
    category: "运动竞技",
    tag: "竞技",
    author: "疾风创作组",
    chapters: 265,
    rating: 9.0,
    views: "1.1亿",
    image: "https://readdy.ai/api/search-image?query=sports%20anime%20comic%20cover%20of%20basketball%20player%20making%20a%20jump%20shot%2C%20dynamic%20motion%2C%20warm%20orange%20stadium%20lights%2C%20energetic%20manga%20illustration&width=600&height=800&seq=cc-comic-06&orientation=portrait",
  },
];

export const stepsGuide = [
  {
    icon: "ri-smartphone-line",
    title: "打开入口",
    desc: "进入虫虫漫画官网，点击顶部或首页的“免费版入口”，直达阅读首页。",
  },
  {
    icon: "ri-user-follow-line",
    title: "一键登录",
    desc: "支持手机号或第三方快捷登录，无需付费即可创建你的专属书架。",
  },
  {
    icon: "ri-book-open-line",
    title: "开始阅读",
    desc: "海量漫画任意挑选，追更、收藏、评论一步到位，零门槛开读。",
  },
];

export const featureList = [
  {
    icon: "ri-coin-line",
    title: "每日免费阅读奖励",
    desc: "通过每日签到与观看时长累计免费阅读时长，所有漫画都能零门槛阅读。",
  },
  {
    icon: "ri-stack-line",
    title: "海量漫画库",
    desc: "热血、恋爱、奇幻、日常等十大分类，上千万话内容持续更新，想看的有。",
  },
  {
    icon: "ri-settings-5-line",
    title: "个性化书架",
    desc: "自动记录阅读进度，收藏、追更、历史一键同步，换设备也能接着看。",
  },
  {
    icon: "ri-voiceprint-line",
    title: "清爽阅读模式",
    desc: "支持夜间模式、翻页与滚动双模式、字号调节，怎么舒服怎么看。",
  },
  {
    icon: "ri-team-line",
    title: "社区评论互动",
    desc: "在每一话下与千万读者交流剧情，发表弹幕与长评，追更不再孤单。",
  },
  {
    icon: "ri-download-2-line",
    title: "离线缓存阅读",
    desc: "免费版支持将章节缓存到本地，通勤路上无网络也能尽情阅读。",
  },
];

export const comparisonRows = [
  {
    feature: "海量漫画库",
    free: "全量阅读",
    paid: "全量阅读",
  },
  {
    feature: "最新章节更新",
    free: "等待解锁",
    paid: "抢先看",
  },
  {
    feature: "页面推广内容",
    free: "包含推广位",
    paid: "纯净无推广",
  },
  {
    feature: "画面清晰度",
    free: "标准清晰度",
    paid: "高清畅享",
  },
  {
    feature: "每日免费奖励",
    free: "每日可领",
    paid: "奖励加成",
  },
  {
    feature: "多设备同步",
    free: "登录后同步",
    paid: "全端同步",
  },
  {
    feature: "离线缓存容量",
    free: "基础容量",
    paid: "扩容翻倍",
  },
  {
    feature: "专属阅读权益",
    free: "基础权益",
    paid: "会员专属",
  },
];

export const limitationList = [
  {
    icon: "ri-time-line",
    title: "新章节等待解锁",
    desc: "部分连载中的最新章节需等待一段时间后免费解锁，热门作品高峰期排队时间会略长。",
  },
  {
    icon: "ri-advertisement-line",
    title: "页内推广位",
    desc: "免费阅读页会展示少量推广内容，以支持平台持续提供免费服务。",
  },
  {
    icon: "ri-hd-line",
    title: "标准清晰度",
    desc: "免费版默认为标准清晰度，高清原画需付费版或使用阅读时长兑换。",
  },
  {
    icon: "ri-user-star-line",
    title: "部分功能需登录",
    desc: "书架同步、离线缓存、评论互动等功能需要登录账号后使用。",
  },
];

export const faqList = [
  {
    q: "虫虫漫画免费版入口在哪里？",
    a: "进入虫虫漫画官网首页，点击顶部或首屏的“免费版入口”按钮即可直达阅读首页。首次进入会提示安装或打开应用，按引导完成即可零门槛开始阅读。",
  },
  {
    q: "免费版和付费版有什么区别？",
    a: "免费版可阅读海量漫画并支持每日阅读奖励，但部分新章节需等待解锁、存在页内推广，画质默认为标准清晰度；付费版则支持最新章节抢先看、高清无推广与多设备同步。",
  },
  {
    q: "免费版真的完全免费吗？",
    a: "是的。虫虫漫画免费版无需付费即可阅读，所有漫画均可通过阅读时长和每日任务免费解锁，不收取任何费用。",
  },
  {
    q: "免费版有哪些限制？",
    a: "主要包括：部分新章更新存在等待解锁、页面内含推广位、标准清晰度以及部分平台功能需要登录后使用等。",
  },
  {
    q: "免费版需要注册账号吗？",
    a: "浏览漫画不强制注册，但注册并登录后可免费使用书架同步、离线缓存与评论互动等功能，推荐注册以获取更完整的阅读体验。",
  },
  {
    q: "如何从免费版升级到付费版？",
    a: "在应用内点击“会员中心”，选择适合的会员套餐即可升级。升级后立即享受最新章节抢先看、高清无推广与多设备同步等全部权益。",
  },
];

export const testimonials = [
  {
    name: "阿黎",
    role: "热血漫爱好者",
    quote: "每天签到领免费时长，追了上百话都没花一分钱，平台真的很良心。",
  },
  {
    name: "小满",
    role: "学生党",
    quote: "睡前用免费时长把喜欢的恋爱漫画读完，夜间模式特别舒服，体验满分。",
  },
  {
    name: "老K",
    role: "老书虫",
    quote: "免费版就能看海量漫画，虽然有些新章要等，但白嫖党表示很满足。",
  },
];